import { render, staticRenderFns } from "./ProfileLanguageAddEdit.vue?vue&type=template&id=69d0e520"
import script from "./ProfileLanguageAddEdit.vue?vue&type=script&lang=js"
export * from "./ProfileLanguageAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports